import { FC, useContext, useEffect, useState } from "react";

import { BoardContext, TableContext, TeamContext, UserContext } from "../../../context";
import { PinkNotification, UpperTokensBar } from "../../atoms";
import { IPlayer } from "../../../interfaces";
import { useSound } from "../../../hooks";
import UpTokenCoin from "../../../assets/icons/upTokenCoin.svg"
import { useTranslation } from "react-i18next";

interface PlayerMiniProfileProps {
    player?: IPlayer
    showNotification?: boolean;
}
const PlayerMiniProfile: FC<PlayerMiniProfileProps> = ({ player, showNotification}) => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const { userData, setEmailOfSelectedPlayerBoard } = useContext(UserContext);
    const { playersInNewOrder } = useContext(UserContext);
    const { instructionTutorial } = useContext(BoardContext);
    const { updateUserAngles } = useContext(TableContext);
    const [numberOfTokens, setNumberOfTokens] = useState(0);
    const [isUpperCoinAnimationActive, setIsUpperCoinAnimationActive] = useState<boolean>(false);
    const {playSound} = useSound();

    useEffect(() => {
        if (player)
            setNumberOfTokens(game?.gameInfo.players[player?.email || ""]?.upperTokens || 0);

        setNumberOfTokens(game?.gameInfo.players[userData?.email || ""]?.upperTokens || 0);
    }, [game, player, userData?.email]);

    useEffect(() => {
        setIsUpperCoinAnimationActive(true);
        playSound("/sounds/CoinCollect.mp3");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [numberOfTokens]);

    const endUpperCoinAnimation = () => {
        setTimeout( () => {
            setIsUpperCoinAnimationActive(false);
        }, 2000);
    }

    if (isUpperCoinAnimationActive) {
        endUpperCoinAnimation();
    }

    const userNickname = () => {
        if (player) return game?.gameInfo.players[player?.email || ""].nickname || 0;
        return playersInNewOrder.find((player: IPlayer) => { return player?.email === userData?.email })?.nickname || "";
    }

    const userColor = () => {
        if (player) return game?.gameInfo.players[player?.email || ""].color || 0;

        return playersInNewOrder.find((player: IPlayer) => { return player?.email === userData?.email })?.color || "";
    }

    const rotateBackToMyCards = () => {
        playersInNewOrder.forEach( (player: IPlayer, index: number) => {
            if(player.email === userData?.email){
                updateUserAngles(index);
                setEmailOfSelectedPlayerBoard(player.email);
            }
        })
    }
    
    return (
        <div className="player_mini_profile_wrapper center_vertically" >

            <div className="player_mini_profile" 
                // Rotation disabled and seeing other players cards
                //onClick={rotateBackToMyCards}
            >
                <img
                    className={`player_mini_profile_image ${instructionTutorial === "leftSideOfTheScreen" && "white_box_shadow_thin"} border_color_${userColor()} `}
                    src={`${process.env.REACT_APP_BACKEND_URL}images/${userData?.email}.png`}
                    alt="Profile Icon"
                />
                <div className="player_mini_profile_personal_data">
                    <div className={`name text_color_${userColor()}`}>
                        {userNickname()}
                    </div>

                    {(instructionTutorial === "leftSideOfTheScreen" && showNotification) && 
                        <div style={{position: "relative"}}>
                            <PinkNotification notificationWidthVW={30} notificationRenderingSide="right" text={t("tipYourGoalIsToEarnAsManyUpperTokensText")} moveFromTop={10} progressNumber={5} /> 
                        </div>
                    }
                    <div className={`user_tokens center_horizontally_and_vertically ${instructionTutorial === "leftSideOfTheScreen" && "white_box_shadow_thin"} ${instructionTutorial === "rightSideOfTheScreen" && "minus_one_zindex"}`}>
                        <div className="upper_token_coin_icon_wrapper">
                            <img
                                className="upper_token_coin_icon"
                                src={UpTokenCoin}
                                alt="edit pen"
                            />
                            {isUpperCoinAnimationActive && <img
                                className="upper_token_coin_icon_animation"
                                src={UpTokenCoin}
                                alt="edit pen"
                            />}
                        </div>
                        <div className="upper_token_coin_text center_horizontally_and_vertically">
                            {<UpperTokensBar numberOfPoints={numberOfTokens} />}
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default PlayerMiniProfile;